<template>
  <!-- 应急救援设备 -->
  <div class="page_box">
    <div class="page_option_box">
      <div class="option_box">
        <el-button
          type="primary"
          size="mini"
          plain
          icon="el-icon-circle-plus-outline"
          @click="dialog.addDialog = true"
          >新增救援器材</el-button
        >
        <el-button
          type="danger"
          size="mini"
          plain
          icon="el-icon-circle-close"
          :disabled="deleteIdList.length == 0 ? true : false"
          @click="delData('', 2)"
          >批量删除</el-button
        >
      </div>
      <div class="search_box">
        <el-input
          v-model.trim="requestParams.name"
          placeholder="请输入器材名称"
          size="mini"
          clearable
        ></el-input>
        <el-select
          v-model="requestParams.status"
          placeholder="请选择器材现状"
          size="mini"
          clearable
        >
          <el-option
            v-for="item in $store.state.select.rescueEquipmentStatus"
            :key="item.id"
            :label="item.nameOne"
            :value="item.id"
          >
          </el-option>
        </el-select>
        <el-button
          icon="el-icon-search"
          type="primary"
          plain
          size="mini"
          @click="searchData"
          >搜索</el-button
        >
      </div>
    </div>
    <div class="page_table_box">
      <div class="school_table_box">
        <el-table
          :data="responseData.list"
          height="100%"
          class="table_box"
          :header-cell-style="{ background: '#E2EEFF', color: '#474859' }"
          @selection-change="tableSelectionChange"
        >
          <el-table-column type="selection" width="40"> </el-table-column>
          <el-table-column label="序号" width="70" align="center">
            <template v-slot="scope">
              {{
                requestParams.pageSize * (requestParams.pageNum - 1) +
                  scope.$index +
                  1
              }}
            </template>
          </el-table-column>

          <el-table-column prop="name" label="器材名称" align="center">
          </el-table-column>

          <el-table-column prop="model" label="器材型号" align="center">
          </el-table-column>

          <el-table-column prop="amount" label="器材数量" align="center">
            <template slot-scope="rowData">
              {{ rowData.row.amount + rowData.row.unit }}
            </template>
          </el-table-column>

          <el-table-column prop="position" label="存放位置" align="center">
          </el-table-column>

          <el-table-column prop="status" label="器材现状" align="center">
            <template slot-scope="rowData">
              {{
                $store.state.select.rescueEquipmentStatus[rowData.row.status]
                  .nameOne
              }}
            </template>
          </el-table-column>

          <el-table-column prop="remark" label="备注" align="center">
          </el-table-column>

          <el-table-column prop="addTime" label="创建时间" align="center">
            <template slot-scope="rowData">
              {{ $Common.dateFormatDateTwo(rowData.row.addTime) }}
            </template>
          </el-table-column>

          <el-table-column label="操作" width="200" align="center">
            <template slot-scope="rowData">
              <el-link
                class="link_box"
                type="primary"
                @click="openEditBox(rowData.row)"
                :underline="false"
                >编辑</el-link
              >
              <el-divider direction="vertical"></el-divider>
              <el-link
                class="link_box"
                type="primary"
                @click="delData(rowData.row.id, 1)"
                :underline="false"
                >删除</el-link
              >
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="pagination_box">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="requestParams.pageNum"
          :page-sizes="[20, 30, 50, 100]"
          :page-size="requestParams.pageSize"
          layout="total, prev, pager, next, jumper"
          :total="responseData.total"
        >
        </el-pagination>
      </div>
      <!-- 新增 -->
      <el-dialog
        :before-close="cancelForm"
        :visible.sync="dialog.addDialog"
        direction="ltr"
        custom-class="demo-drawer"
        ref="drawer"
        append-to-body
        title="新增"
        size="30%"
        :wrapperClosable="false"
        :close-on-press-escape="false"
      >
        <div class="demo-drawer__content ">
          <form class="form-horizontal form_box">
            <div class="form-group">
              <label class="col-sm-2 control-label">器材名称</label>
              <div class="col-sm-10">
                <input
                  type="text"
                  class="form-control"
                  v-model.trim="insertData.name"
                  placeholder="器材名称"
                />
              </div>
            </div>

            <div class="form-group">
              <label class="col-sm-2 control-label">器材型号</label>
              <div class="col-sm-10">
                <input
                  type="text"
                  class="form-control"
                  v-model.trim="insertData.model"
                  placeholder="器材型号"
                />
              </div>
            </div>

            <div class="form-group">
              <label class="col-sm-2 control-label">器材数量</label>
              <div class="col-sm-10">
                <input
                  type="number"
                  class="form-control"
                  v-model.trim="insertData.amount"
                  placeholder="器材数量"
                />
              </div>
            </div>
            <div class="form-group">
              <label class="col-sm-2 control-label">计量单位</label>
              <div class="col-sm-10">
                <input
                  type="text"
                  class="form-control"
                  v-model.trim="insertData.unit"
                  placeholder="计量单位"
                />
              </div>
            </div>

            <div class="form-group">
              <label class="col-sm-2 control-label">器材状态</label>
              <div class="col-sm-10">
                <select class="form-control" v-model="insertData.status">
                  <option
                    v-for="value in $store.state.select.rescueEquipmentStatus"
                    :key="value.id"
                    :value="value.id"
                  >
                    {{ value.nameOne }}
                  </option>
                </select>
              </div>
            </div>

            <div class="form-group">
              <label class="col-sm-2 control-label">存放位置</label>
              <div class="col-sm-10">
                <input
                  type="text"
                  class="form-control"
                  v-model.trim="insertData.position"
                  placeholder="存放位置"
                />
              </div>
            </div>

            <div class="form-group">
              <label class="col-sm-2 control-label">备注</label>
              <div class="col-sm-10">
                <textarea
                  class="form-control"
                  rows="3"
                  v-model.trim="insertData.remark"
                  maxlength="30"
                ></textarea>
                <span id="helpBlock2" class="help-block"
                  >（填写不超过30字备注）</span
                >
              </div>
            </div>

            <div class="form-group">
              <label for="inputEmail3" class="col-sm-2 control-label"></label>
              <div class="col-sm-10">
                <el-button size="mini" type="primary" @click="dataOperation(1)"
                  >确定添加</el-button
                >
                <el-button size="mini" @click="cancelForm">返回</el-button>
              </div>
            </div>
          </form>
        </div>
      </el-dialog>

      <!-- 编辑 -->
      <el-dialog
        :before-close="cancelForm"
        :visible.sync="dialog.editDialog"
        direction="ltr"
        custom-class="demo-drawer"
        ref="drawer"
         width="800px"
        append-to-body
        size="30%"
        title="编辑"
        :wrapperClosable="false"
        :close-on-press-escape="false"
      >
        <div class="demo-drawer__content ">
          <form class="form-horizontal form_box">
            <div class="form-group">
              <label class="col-sm-2 control-label">器材名称</label>
              <div class="col-sm-10">
                <input
                  type="text"
                  class="form-control"
                  v-model.trim="editData.name"
                  placeholder="器材名称"
                />
              </div>
            </div>

            <div class="form-group">
              <label class="col-sm-2 control-label">器材型号</label>
              <div class="col-sm-10">
                <input
                  type="text"
                  class="form-control"
                  v-model.trim="editData.model"
                  placeholder="器材型号"
                />
              </div>
            </div>

            <div class="form-group">
              <label class="col-sm-2 control-label">器材数量</label>
              <div class="col-sm-10">
                <input
                  type="number"
                  class="form-control"
                  v-model.trim="editData.amount"
                  placeholder="器材数量"
                />
              </div>
            </div>
            <div class="form-group">
              <label class="col-sm-2 control-label">计量单位</label>
              <div class="col-sm-10">
                <input
                  type="text"
                  class="form-control"
                  v-model.trim="editData.unit"
                  placeholder="计量单位"
                />
                <span id="helpBlock2" class="help-block"
                  >（如：个，件，把）</span
                >
              </div>
            </div>

            <div class="form-group">
              <label class="col-sm-2 control-label">器材状态</label>
              <div class="col-sm-10">
                <select class="form-control" v-model="editData.status">
                  <option value="">请选择</option>
                  <option
                    v-for="value in $store.state.select.rescueEquipmentStatus"
                    :key="value.id"
                    :value="value.id"
                  >
                    {{ value.nameOne }}
                  </option>
                </select>
              </div>
            </div>

            <div class="form-group">
              <label class="col-sm-2 control-label">存放位置</label>
              <div class="col-sm-10">
                <input
                  type="text"
                  class="form-control"
                  v-model.trim="editData.position"
                  placeholder="存放位置"
                />
              </div>
            </div>

            <div class="form-group">
              <label class="col-sm-2 control-label">备注</label>
              <div class="col-sm-10">
                <textarea
                  class="form-control"
                  rows="3"
                  v-model.trim="editData.remark"
                  maxlength="30"
                ></textarea>
                <span id="helpBlock2" class="help-block"
                  >（填写不超过30字备注）</span
                >
              </div>
            </div>

            <div class="form-group">
              <label class="col-sm-2 control-label"></label>
              <div class="col-sm-10">
                <el-button size="mini" type="primary" @click="dataOperation(2)"
                  >确定修改</el-button
                >
                <el-button size="mini" @click="cancelForm">返回</el-button>
              </div>
            </div>
          </form>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import SafetyDrillSettings from "@/components/SafetyDrillSettings";

export default {
  name: "",
  components: { SafetyDrillSettings },
  props: {},
  data() {
    return {
      dialog: {
        addDialog: false,
        editDialog: false
      },
      // 响应数据
      responseData: {
        pageSize: 0,
        pageNum: 0,
        total: 0,
        pages: 0,
        list: []
      },
      // 请求数据
      requestParams: {
        schoolId: this.$store.state.schoolId,
        pageNum: 1,
        name: "",
        pageSize: 20,
        status: ""
      },
      insertData: {
        name: "",
        model: "",
        amount: "",
        unit: "",
        status: "",
        position: "",
        remark: "",
        schoolId: this.$store.state.schoolId
      },
      editData: {
        id: "",
        name: "",
        model: "",
        amount: "",
        unit: "",
        status: "",
        position: "",
        remark: "",
        schoolId: this.$store.state.schoolId
      },

      deleteIdList: []
    };
  },
  watch: {},
  computed: {},
  methods: {
    searchData() {
      this.requestParams.pageNum = 1;
      this.getDataList();
    },
    openEditBox(thisData) {
      this.editData.id = thisData.id;
      this.editData.name = thisData.name;
      this.editData.model = thisData.model;
      this.editData.amount = thisData.amount;
      this.editData.unit = thisData.unit;
      this.editData.status = thisData.status;
      this.editData.position = thisData.position;
      this.editData.remark = thisData.remark;
      this.dialog.editDialog = true;
    },
    handleCurrentChange(val) {
      this.requestParams.pageNum = val;
      this.getDataList();
      console.log(`当前页: ${val}`);
    },
    // 选择要删除的数据
    tableSelectionChange(val) {
      var deleteDataId = [];
      val.forEach((element) => {
        deleteDataId.push(element.id);
      });
      this.deleteIdList = deleteDataId;
    },
    // 新增 / 编辑
    async dataOperation(operation = 1) {
      var newRequestData = this.insertData;
      if (operation == 2) {
        var newRequestData = this.editData;
      }
      if (!newRequestData.name) {
        this.$message("请填写器材名称！");
        return;
      }
      if (!newRequestData.model) {
        this.$message("请填写器材型号！");
        return;
      }
      if (!newRequestData.amount) {
        this.$message("请填写器材数量！");
        return;
      }
      if (!newRequestData.unit) {
        this.$message("请填写计量单位！");
        return;
      }
      if (newRequestData.status === "") {
        this.$message("请选择器材状态！");
        return;
      }
      if (!newRequestData.position) {
        this.$message("请填写存放位置！");
        return;
      }
      let res = await this.$Http.rescueEquipmentOperation(newRequestData, true);
      if (res.code == 200) {
        this.$message({
          type: "success",
          message: res.messsage
        });
        this.cancelForm();
        this.getDataList();
      } else if (res.code == 101) {
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    },

    // 获取数据
    async getDataList() {
      var newParamData = {
        schoolId: this.requestParams.schoolId,
        pageNum: this.requestParams.pageNum,
        pageSize: this.requestParams.pageSize,
        name: this.requestParams.name,
        status: this.requestParams.status
      };

      let res = await this.$Http.getRescueEquipment(newParamData);
      if (res.code == 200) {
        this.responseData.pageSize = res.data.pageSize;
        this.responseData.pageNum = res.data.pageNum;
        this.responseData.total = res.data.total;
        this.responseData.pages = res.data.pages;
        this.responseData.list = res.data.list;
      } else if (res.code == 101) {
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    },

    // 删除数据
    delData(dataId, cate) {
      this.$confirm("确定要删除吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          if (cate == 1) {
            var requestData = {
              id: dataId
            };
            var res = await this.$Http.delRescueEquipment(requestData);
          } else {
            if (this.deleteIdList.length < 1) {
              this.$message({
                type: "error",
                message: "请先选择您要删除的数据"
              });
              return false;
            }
            var requestData = {
              ids: this.deleteIdList
            };
            var res = await this.$Http.batchDeleteRescueEquipment(
              requestData,
              true
            );
          }

          if (res.code == 200) {
            this.$message({
              type: "success",
              message: "删除成功!"
            });
            this.getDataList();
          } else if (res.code == 101) {
          } else {
            this.$message({
              type: "error",
              message: res.messsage
            });
          }
        })
        .catch(() => {});
    },

    cancelForm() {
      this.dialog.addDialog = false;
      this.dialog.editDialog = false;
      clearTimeout(this.timer);
    }
  },
  created() {},
  mounted() {
    this.getDataList();
  }
};
</script>
<style scoped></style>
